import { common } from './common.icons';

export const IconGrid2 = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 24 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-grid2 ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <rect x="1.33398" y="0.833313" width="8.53333" height="8.53333" stroke="" strokeWidth="0.933333" />
      <rect x="1.33398" y="13.6332" width="8.53333" height="8.53333" stroke="" strokeWidth="0.933333" />
      <rect x="14.1348" y="0.833252" width="8.53333" height="8.53333" stroke="" strokeWidth="0.933333" />
      <rect x="14.1348" y="13.6332" width="8.53333" height="8.53333" stroke="" strokeWidth="0.933333" />
    </svg>
  );
};
